<div class="content-map">
  <div style="height: 100%; width: 100%;"
       leaflet
       [leafletFitBounds]="fitBounds"
       [leafletZoom]="mapZoom"
       [leafletCenter]="mapCenterOptions"
       [leafletOptions]="options"
       [leafletLayers]="markers">
  </div>
</div>
